module.exports = __webpack_public_path__ + "static/img/connect-account.fd61c036.svg";